// extracted by mini-css-extract-plugin
export default {"overview":"Analytics_overview__Zv0HL","tabs":"Analytics_tabs__FdwsJ"};